import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToastModule } from 'primeng/toast';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { entite } from 'src/app/models/entite';
import { ProfilDto } from 'src/app/models/ProfilDto';
import { collabService } from 'src/app/services/collab/collabService.service';
import { EntitebackService } from 'src/app/services/entite/entiteback.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';

@Component({
  selector: 'app-form-vendeur',
  templateUrl: './form-vendeur.component.html',
  imports: [CommonModule,FormsModule,ToastModule,ButtonModule,ReactiveFormsModule,InputTextModule,SelectButtonModule,SelectModule,ButtonModule,ProgressBarModule,ToggleSwitchModule],
  styleUrls: ['./form-vendeur.component.scss']
})
export class FormVendeurComponent implements OnInit {
  selectedEntite!: entite;
  libelleselected: string = '';
  emailuserconnecte!: string | undefined;

  statutVendeur: boolean = true;
  prenomSelected: any;
  emailSelected: any;
  telephoneSelected: any;
  vendeuraAjoute: any = {
    nom: '',
    prenom: '',
    telgsm: '',
    actif: '',
    web: '',
    mail: '',
    numEntite: '',
    user: '',
    profil: '',
    titre: '',
    numCollab: '',

  };
  selectedProfil: ProfilDto | undefined;
  titreselected: any;
  profils: ProfilDto[] | undefined;
  @Output() closeDialog = new EventEmitter<void>();

  constructor(private router: Router,
    public share: shareOpeSevices,
    private readonly entiteservice: EntitebackService,
    private readonly fb: FormBuilder, private readonly collabservice: collabService,
    public messageService: MessageService, private readonly kcService: KeycloakService) { }
  entites!: entite[]
  ngOnInit(): void {

    this.share.noeudficheEntite$.subscribe(data => {

      this.selectedEntite = data;
    });
    this.entiteservice.getAllEntites().subscribe((data: entite[]) => {
      this.entites = data;
    });
    this.collabservice.getProfils().subscribe(data => {

      this.profils = data
    })

    this.emailuserconnecte = this.kcService.getUsername();
    /*this.share.userProfilshared$.subscribe(data=>{
      this.emailuserconnecte = data.mail;
    

    })*/
  }

  entiteForm = this.fb.group({
    nom: ['', [Validators.required, Validators.pattern('^[a-zA-ZÀ-ÿ\\s\\-]{3,}$')]],
    prenom: ['', [Validators.required, Validators.pattern('^[a-zA-ZÀ-ÿ\\s\\-]{3,}$')]],
    type: [""],
    adressmail: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}')]],

    actif: ['', Validators.requiredTrue],
    telephone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    entite: ['', Validators.required],
    titre: [''],
    profil: ['', Validators.required]
  });

  add() {
    this.share.showprogressbar = true;
    this.vendeuraAjoute.nom = this.libelleselected;
    this.vendeuraAjoute.prenom = this.prenomSelected;
    this.vendeuraAjoute.telgsm = this.telephoneSelected;
    this.vendeuraAjoute.actif = this.entiteForm.value.actif;
    this.vendeuraAjoute.web = '1';
    this.vendeuraAjoute.mail = this.emailSelected;
    this.vendeuraAjoute.numEntite = this.selectedEntite.numEntite;
    this.vendeuraAjoute.user = this.emailuserconnecte;
    this.vendeuraAjoute.profil = this.selectedProfil ? this.selectedProfil.a1CODE : null;
    this.vendeuraAjoute.titre = this.titreselected;


    this.collabservice.addCollab(this.vendeuraAjoute).subscribe({
      next: (data: any) => {

        if (data != null) {
          this.share.showprogressbar = false;
          this.messageService.add({ severity: 'success', detail: `${data.nom} ${data.prenom} a été ajoutée avec succés` });
          this.entiteForm.reset();
          this.collabservice.getcollab();
        }
        else {
          this.share.showprogressbar = false;
          this.messageService.add({ severity: 'warn', detail: `Erreur ` + ` ${data}` });

        }
        this.router.navigate([`/page-vendeurs`])
      },
      error: (err) => {
        this.share.showprogressbar = false;
        this.messageService.add({ severity: 'error', detail: `Erreur ` + ` ${err.error.message}` });
        this.router.navigate([`/page-vendeurs`])
      },
      complete: () => {
        this.closeDialog.emit();
        this.share.sendRefrechVendeurs(true);
      }
    })




  }
}
